<template>
  <div class="pro-bim">
    <h2 class="is-size-2 has-text-weight-semibold title has-text-dark">Autodesk</h2>
    <h3 class="is-size-3 has-text-weight-bold title line-height">BIM 360 Viewer</h3>      
    <h4 class="is-size-5 line-height  mb-3">
      {{ bimText.msg }}
    </h4>
    <button
      v-permission="{permissionModule: 'app&projects', type: 'thirdPartyPlugins'}"
      class="button has-background-black-bis has-text-white is-medium"
      @click="bim360Oauth">{{ bimText.authButton }}</button>
  </div>
</template>
<script>
import { computed, onMounted, reactive, toRefs } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { isEmpty } from 'lodash';
export default({
  name: 'ForgeUser',
  setup() {
    const store = useStore();
    const router = useRouter();
    const data = reactive({
      isForgeUser: false,
      edit: false,
    });

    const bimText = computed(() => {
      let msg = 'Enable ACC/BIM 360 to view models and sheets.';
      let authButton = 'Enable ACC/BIM 360';
      if (data.isForgeUser) {
        authButton = 'CHANGE';
        msg = 'BIM Viewing is currently enabled.'
          + ' To set up a model for viewing, go to project Company Project settings.';
      }
      return { msg, authButton };
    });
    const bim360Oauth = () => {
      router.push({ name: 'forge-authorize', params: { oauth: 'authorize' } });
    };
    onMounted(async () => {
      await store.getters.userPromise;
      const user = store.state.userData;
      data.isForgeUser = !isEmpty(user.forgeCredentials);
    });
    return {
      ...toRefs(data),
      bimText,
      bim360Oauth,
    };
  },
});
</script>
